"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.servicesUISchemaMapper = servicesUISchemaMapper;
const utils_1 = require("../../../utils");
function makeServiceUISchema(key) {
    return {
        type: "Control",
        scope: `#/properties/services/properties/${key}`,
        options: {
            format: "radio",
        },
    };
}
function makeFrequencyUISchema(serviceKey) {
    return {
        type: "Control",
        scope: `#/properties/services/properties/${serviceKey.toLowerCase()}Frequency`,
        rule: {
            effect: "SHOW",
            condition: {
                scope: `#/properties/services/properties/${serviceKey}`,
                schema: {
                    const: "1",
                },
            },
        },
    };
}
function makeServicesUISchema(services, withFrequency) {
    // Group each service with its optional frequency as a unit
    // so they are never split across columns
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const serviceGroups = [];
    for (let i = 0; i < services.length; i++) {
        const service = services[i];
        const group = [makeServiceUISchema(service.shortHand)];
        if (withFrequency && withFrequency.includes(service.shortHand)) {
            group.push(makeFrequencyUISchema(service.shortHand));
        }
        serviceGroups.push(group);
    }
    const allElements = serviceGroups.flat();
    if (allElements.length < 4) {
        return allElements;
    }
    const [groupsOne, groupsTwo] = (0, utils_1.splitArrayMidway)(serviceGroups);
    return [
        {
            type: "HorizontalLayout",
            elements: [
                {
                    type: "VerticalLayout",
                    elements: groupsOne.flat(),
                },
                {
                    type: "VerticalLayout",
                    elements: groupsTwo.flat(),
                },
            ],
        },
    ];
}
function servicesUISchemaMapper(template, services, serviceFrequencies) {
    const serviceUiSchema = {
        type: "Group",
        label: "Services",
        elements: makeServicesUISchema(services, serviceFrequencies),
    };
    const existingIndex = template.uiSchema.elements.findIndex((element) => element.label === "Services");
    if (existingIndex !== -1) {
        template.uiSchema.elements.splice(existingIndex, 1);
    }
    template.uiSchema.elements.splice(template.uiSchema.elements.length - 1, 0, serviceUiSchema);
    return template;
}
